export default [
    {
        path: '/student-vehicles',
        name: 'student-vehicle',
        meta: { requiresAuth: true },
        component: () => import('@/pages/student-vehicle/index.vue')
    },
    {
        path: '/student-vehicles-create',
        name: 'student-vehicle-create',
        meta: { requiresAuth: true },
        component: () => import('@/pages/student-vehicle/create.vue')
    }
]
